/** 各フェーズ定義 */
export const PHASE = {
  START: 'start', // 待機
  HISTORY_LIST: 'history_list', // 履歴情報表示
  EXECUTION: 'execution', // 実行中
  SUCCESS: 'success', // 停止
  FAILED_READ: 'failed_read', // 失敗表示
  FAILED_SAVE: 'failed_save', // エラー
  ERROR: 'error' // 共通エラー
};

/** 現在セッション */
export const SESSION_PROPERTY = {
  DEFAULT: 0,
  NON_DEFAULT: 1
};